import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { ContentItemPostiesPrimary } from "scmp-app/components/content/content-item-render/variants/posties-primary";
import { Headline as ContentItemPostiesPrimaryHeadline } from "scmp-app/components/content/content-item-render/variants/posties-primary/styles";
import { Headline } from "scmp-app/components/posties/content-homepage/headline";

import HahaLeft from "./haha-left.svg?url";
import HahaRight from "./haha-right.svg?url";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  position: relative;

  padding-block: 64px 94px;

  background-color: #ffffff;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 145.44px 109.9px;
    padding-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block: 88px 91px;
  }

  ${theme.breakpoints.up("desktop")} {
    padding-block-start: 97px;
  }

  ${theme.breakpoints.up("largeDesktop")} {
    &:before {
      position: absolute;
      inset-block-start: 178.75px;
      inset-inline-start: 0;
      content: "";

      inline-size: 282.876px;
      block-size: 289.777px;

      background-image: url(${HahaLeft});
      background-repeat: no-repeat;
      background-size: contain;
    }
    &:after {
      position: absolute;
      inset-block-end: 2.45px;
      inset-inline-end: 0;
      content: "";

      inline-size: 416.971px;
      block-size: 416.971px;

      background-image: url(${HahaRight});
      background-repeat: no-repeat;
      background-position-x: right;
      background-size: contain;
    }
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-block-end: 24px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 56px;
  }
`;

export const StyledContentItemPostiesPrimary = styled(ContentItemPostiesPrimary)`
  position: relative;

  ${ContentItemPostiesPrimaryHeadline} {
    color: #1b4191;
  }
`;

export const Content = styled.div`
  inline-size: 100%;
`;
